/**
 * Single readiness decision for mode-sensitive shell + GPS clamp.
 *
 * shellDecided =
 *   !needsPublicConfig  → local shell is complete (admin Live / no widgetId)
 *   needsPublicConfig   → true only after public fetch settles (success or fail-open)
 */
export function isShellDecided(
  needsPublicConfig: boolean,
  remoteSettled: boolean
): boolean {
  return !needsPublicConfig || remoteSettled;
}
